import { ComponentPropsWithoutRef, forwardRef } from "react";
import * as styles from "./WrapperInteractionRoot.css";
import clsx from "clsx";

type WrapperInteractionRootProps = ComponentPropsWithoutRef<"div">;

export const WrapperInteractionRoot = forwardRef<
  HTMLDivElement,
  WrapperInteractionRootProps
>(({ children, className, ...props }, ref) => {
  
  return (
    <div className={clsx(className, styles.root)} {...props} ref={ref}>
      {children}
    </div>
  );
});
